// import { defaultLocale, localeOptions } from '../../constants/defaultValues'

import {
	LOGOUT_USER,

	// User Management
	SETTING_LOAD_PERMISSION,
	SETTING_LOAD_PERMISSION_SUCCESS,
	SETTING_CREATE_PERMISSION,
	SETTING_UPDATE_PERMISSION,
	SETTING_DELETE_PERMISSION,

	SETTING_LOAD_USER,
	SETTING_LOAD_USER_SUCCESS,
	SETTING_CREATE_USER,
	SETTING_UPDATE_USER,
	SETTING_DELETE_USER,

	SETTING_CREATE_USER_PASS,
	SETTING_RESET_USER_PASS

	// END User Management


} from '../../actions';

const INIT_STATE = {

	permission: [],
	optionPermission: [],

	userlists: [],
	optionUserlists: [],

	permissionLoading: false,
	userLoading: false,

};

export default (state = INIT_STATE, action) => {
	switch (action.type) {

		case SETTING_LOAD_PERMISSION:
			return { ...state, permissionLoading: true }
		case SETTING_LOAD_PERMISSION_SUCCESS:
			return {
				...state,
				permissionLoading: false,
				permission: action.payload,
				optionPermission: action.payloadlist
			}
		case SETTING_CREATE_PERMISSION:
			return { ...state, permissionLoading: true }
		case SETTING_UPDATE_PERMISSION:
			return { ...state, permissionLoading: true }
		case SETTING_DELETE_PERMISSION:
			return { ...state, permissionLoading: true }

		case SETTING_LOAD_USER:
			return { ...state, userLoading: true }
		case SETTING_LOAD_USER_SUCCESS:
			return {
				...state,
				userLoading: false,
				userlists: action.payload,
				optionUserlists: action.payloadlist
			}
		case SETTING_CREATE_USER:
			return { ...state, userLoading: true }
		case SETTING_UPDATE_USER:
			return { ...state, userLoading: true }
		case SETTING_DELETE_USER:
			return { ...state, userLoading: true }

		case SETTING_CREATE_USER_PASS:
			return { ...state, userLoading: true }
		case SETTING_RESET_USER_PASS:
			return { ...state, userLoading: true }

		case LOGOUT_USER:
			return {
				...state,
				permission: [],
				optionPermission: [],

				userlists: [],
				optionUserlists: [],

				permissionLoading: false,
				userLoading: false,
			};

		default: return { ...state };
	}
}